import { useStudentGet } from 'actions/studentsv2';
import { useHistory } from 'react-router-dom';

export default function useGetStudentInfo() {
  const history = useHistory();
  const {
    location: { pathname },
  } = history;

  const pathList = pathname && pathname.split('/');
  const studentId = pathList && pathList[pathList.length - 1];
  const { data: studentDetail } = useStudentGet(studentId);

  return studentDetail || {};
}
